import React from "react";
import { ApiResponse } from "../../../api/api";
import { useSession } from "../../../state/api/session/useSession";
import { Dialog, DialogBody, DialogFooter, ModalForm } from "../modal/ModalForm";
import Button, { ButtonBase } from "./Button";
import Submit from "./Submit";

interface Props extends ButtonBase {
  apiCall: () => Promise<ApiResponse<any>>,
  afterDelete?: () => (Promise<any> | any);
}

export default function DeleteButton(props: Props) {

  const { session } = useSession();

  if (!session?.isAdmin) {
    return null;
  }

  return (
    <Dialog
      trigger={(
        <Button
          color="var(--bs-danger)"
          text="Delete"
          icon="trash"
          {...props}
        />
      )}
      dialog={<DeleteButtonInner {...props} />}
    />
  )
}

function DeleteButtonInner(props: Props) {

  const { apiCall, afterDelete } = props;

  return (
    <ModalForm
      title="Confirm Deletion"
      description="Make sure you want to delete this item"
      initialValues={{}}
      onSubmit={async (_, callApi) => {
        const res = await callApi(apiCall());

        if (!res.success) {
          return false;
        }

        await afterDelete?.();
        return true;
      }}
    >
      {
        formik => (
          <>
            <DialogBody>
              <p>Are you sure you want to delete this item? This action cannot be undone.</p>
            </DialogBody>
            <DialogFooter>
              <Submit text="Confirm Delete" color="var(--bs-danger)" icon="radioactive" />
            </DialogFooter>
          </>
        )
      }
    </ModalForm>
  )
}